import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const EmailIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 21"
    {...props}
  >
      <g fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fillRule="nonzero">
              <path d="M.5.3v20.3h26V.3H.5zm22.5 2l-9.6 9.3L4 2.3h19zM2.5 18.7v-15l11 10.7 11-10.7v15h-22z"></path>
          </g>
      </g>
  </SvgIcon>
);
